// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E2eeDisclaimerPopup__popup-a9f0e1 {
  width: 100%;
  height: fit-content;
  max-width: 440px;
  flex: initial;
}

.E2eeDisclaimerPopup__wrapper-ce1966 {
  overflow-y: auto;
  height: 100%;
  width: 100%;
  background: var(--gradient-10);
  background-size: 100% 258px;
  background-repeat: no-repeat;
  padding: 24px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.E2eeDisclaimerPopup__closeIcon-f39b74 {
  position: absolute;
  top: 16px;
  inset-inline-end: 16px;
  z-index: 2;
}

.E2eeDisclaimerPopup__logo-e2467d {
  width: 120px;
  height: 120px;
  margin: 24px 0;
}

.E2eeDisclaimerPopup__title-f2a9fd {
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  background-image: var(--gradient-0);
  font: var(--font-title-6);
  margin-top: 24px;
  letter-spacing: var(--font-spacing-title-6);
  margin-bottom: 16px;
  text-align: center;
}

.E2eeDisclaimerPopup__list-ef0c1d {
  margin: 0 0 24px 0;
}

.E2eeDisclaimerPopup__list-ef0c1d li {
  padding: 8px 0;
  color: var(--base-120);
  font: var(--font-body-4);
  --font-spacing: var(--font-spacing-body-4);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/E2eeDisclaimerPopup/E2eeDisclaimerPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,6BAAA;EACA,qBAAA;EACA,mCAAA;EACA,yBAAA;EACA,gBAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,sBAAA;EACA,wBAAA;EACA,0CAAA;AACF","sourcesContent":[".popup {\n  width: 100%;\n  height: fit-content;\n  max-width: 440px;\n  flex: initial;\n}\n\n.wrapper {\n  overflow-y: auto;\n  height: 100%;\n  width: 100%;\n  background: var(--gradient-10);\n  background-size: 100% 258px;\n  background-repeat: no-repeat;\n  padding: 24px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.closeIcon {\n  position: absolute;\n  top: 16px;\n  inset-inline-end: 16px;\n  z-index: 2;\n}\n\n.logo {\n  width: 120px;\n  height: 120px;\n  margin: 24px 0;\n}\n\n.title {\n  color: transparent;\n  -webkit-background-clip: text;\n  background-clip: text;\n  background-image: var(--gradient-0);\n  font: var(--font-title-6);\n  margin-top: 24px;\n  letter-spacing: var(--font-spacing-title-6);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.list {\n  margin: 0 0 24px 0;\n}\n\n.list li {\n  padding: 8px 0;\n  color: var(--base-120);\n  font: var(--font-body-4);\n  --font-spacing: var(--font-spacing-body-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `E2eeDisclaimerPopup__popup-a9f0e1`,
	"wrapper": `E2eeDisclaimerPopup__wrapper-ce1966`,
	"closeIcon": `E2eeDisclaimerPopup__closeIcon-f39b74`,
	"logo": `E2eeDisclaimerPopup__logo-e2467d`,
	"title": `E2eeDisclaimerPopup__title-f2a9fd`,
	"list": `E2eeDisclaimerPopup__list-ef0c1d`
};
module.exports = ___CSS_LOADER_EXPORT___;
